import React, { useState } from 'react';
import { useAuthStore } from '../store';
import { resendVerificationEmail } from '../api';

export function EmailVerificationBanner() {
  const user = useAuthStore(state => state.user);
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  if (!user) return null;
  if (user.is_admin) return null;
  if (user.email_verified) return null;

  const handleResend = async () => {
    setStatus('sending');
    try {
      await resendVerificationEmail();
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="mb-6 bg-amber-900/30 border border-amber-700/50 rounded-lg px-4 py-3">
      <div className="flex items-start gap-3">
        <svg className="w-5 h-5 text-amber-400 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-amber-200">
            Verify your email (<span className="font-medium">{user.email}</span>) to purchase credits.
          </p>
          <div className="mt-2">
            {status === 'sent' ? (
              <span className="text-xs text-green-400">Verification email sent! Check your inbox.</span>
            ) : status === 'error' ? (
              <button onClick={handleResend} className="text-xs text-amber-300 hover:text-amber-100 underline">
                Failed to send. Try again?
              </button>
            ) : (
              <button
                onClick={handleResend}
                disabled={status === 'sending'}
                className="text-xs text-amber-300 hover:text-amber-100 underline disabled:opacity-50 disabled:no-underline"
              >
                {status === 'sending' ? 'Sending...' : 'Resend verification email'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
